import { useEffect } from "react";
import { useHistory } from "@/compat/router";

function RequiresRoleWrapper({ hasRole, children }) {
  const history = useHistory();

    useEffect(() => {
    if (!hasRole) history.push("/");
  }, [hasRole]);

  return children;
}

export default RequiresRoleWrapper;
